import React from 'react';
import LoadingSpinnerDarkSvg from '../../svg/loading-spin-dark.svg';
import LoadingSpinnerSvg from '../../svg/loading-spin.svg';

export interface LoadingSpinnerProps {
  colorMode?: 'light' | 'dark';
  style?: React.CSSProperties;
  size?: number;
  spinnerStyle?: React.ImgHTMLAttributes<HTMLImageElement>;
  className?: string;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  colorMode = 'light',
  style = undefined,
  size,
  spinnerStyle,
  className,
}) => {
  const svg = colorMode.toLowerCase() === 'dark' ? LoadingSpinnerDarkSvg : LoadingSpinnerSvg;
  const imageStyle = size ? { width: `${size}px`, height: `${size}px` } : undefined;

  return (
    <span style={style} className={className}>
      <img src={svg} style={imageStyle} {...spinnerStyle} />
    </span>
  );
};
